function getYouTubeIdFromUrl(url) {
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.replace(/^www\./, '');

    if (hostname === 'youtu.be') {
      return parsedUrl.pathname.split('/').filter(Boolean)[0] || '';
    }

    if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
      if (parsedUrl.pathname === '/watch') {
        return parsedUrl.searchParams.get('v') || '';
      }

      const pathParts = parsedUrl.pathname.split('/').filter(Boolean);

      if (pathParts[0] === 'shorts' || pathParts[0] === 'embed') {
        return pathParts[1] || '';
      }
    }
  } catch {
    return '';
  }

  return '';
}

export function getYouTubeEmbedUrl(url, autoplay = false) {
  const videoId = getYouTubeIdFromUrl(url);

  if (!videoId) {
    return '';
  }

  const params = new URLSearchParams({
    playsinline: '1',
    rel: '0',
    modestbranding: '1',
  });

  if (autoplay) {
    params.set('autoplay', '1');
    params.set('mute', '1');
  }

  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
}

export function isYouTubeUrl(url) {
  return Boolean(getYouTubeEmbedUrl(url));
}

function isFacebookHost(hostname) {
  return ['facebook.com', 'm.facebook.com', 'web.facebook.com', 'fb.watch'].includes(hostname);
}

export function getFacebookEmbedUrl(url, autoplay = false) {
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.replace(/^www\./, '');

    if (!isFacebookHost(hostname)) {
      return '';
    }

    const params = new URLSearchParams({
      href: url,
      show_text: 'false',
      width: '500',
    });

    if (autoplay) {
      params.set('autoplay', 'true');
    }

    return `https://www.facebook.com/plugins/video.php?${params.toString()}`;
  } catch {
    return '';
  }
}

export function getVideoEmbedUrl(url, autoplay = false) {
  return getYouTubeEmbedUrl(url, autoplay) || getFacebookEmbedUrl(url, autoplay);
}
